import { FixaTextArea } from "@coworker/apprestructured/src/shared/wrappers/FixaTextArea/FixaTextArea";
import InputWrapper from "@coworker/apprestructured/src/task-management/components/InputWrapper/InputWrapper";
import { useTranslation } from "@coworker/locales";
import styles from "./TitledTextArea.module.css";

type TitledTextAreaProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  disabled?: boolean;
};

function TitledTextArea({
  label,
  value,
  onChange,
  error,
  disabled,
}: TitledTextAreaProps) {
  const { t } = useTranslation();

  return (
    <div className={styles["root"]}>
      <InputWrapper error={error}>
        <FixaTextArea
          label={t(label)}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={3}
          disabled={disabled}
        />
      </InputWrapper>
    </div>
  );
}

export default TitledTextArea;
